// Optimized Shopify Performance Script

// Configuration
const config = {
  lazyLoadOffset: 200, // Load resources when they're 200px from viewport
  criticalResourcesSelector: 'link[rel="stylesheet"], style:not([type="lazyload2"])', // Critical CSS and fonts
  deferredTimeout: 2000 // Load deferred scripts after 2000ms
};

// Helper functions
const isInViewport = (el, offset = 0) => {
  const rect = el.getBoundingClientRect();
  return rect.top <= window.innerHeight + offset && rect.bottom >= 0 - offset;
};

const loadResource = (el) => {
  if (el.tagName === 'IMG') {
    el.src = el.dataset.src;
    el.srcset = el.dataset.srcset || '';
  } else if (el.tagName === 'IFRAME') {
    el.src = el.dataset.src;
  } else {
    el.style = el.dataset.style || el.dataset.mobstyle;
  }
  el.classList.remove('lazy2', 'lazy3', 'lazybg');
};

// Main functions
function initializeLazyLoading() {
  const lazyElements = document.querySelectorAll('.lazy2, .lazy3, .lazybg');
  lazyElements.forEach(el => {
    if (isInViewport(el, config.lazyLoadOffset)) {
      loadResource(el);
    }
  });
}

function loadCriticalResources() {
  const criticalResources = document.querySelectorAll(config.criticalResourcesSelector);
  criticalResources.forEach(el => {
    if (el.tagName === 'LINK' && el.dataset.href) {
      el.href = el.dataset.href;
      delete el.dataset.href;
    }
  });
}

function loadDeferredScripts() {
  const deferredScripts = document.querySelectorAll('script[type="lazyload2"]');
  deferredScripts.forEach(script => {
    const newScript = document.createElement('script');
    Array.from(script.attributes).forEach(attr => {
      if (attr.name !== 'type' && attr.name !== 'data-src') {
        newScript.setAttribute(attr.name, attr.value);
      }
    });
    newScript.src = script.dataset.src || '';
    newScript.textContent = script.textContent;
    script.parentNode.replaceChild(newScript, script);
  });
}

// Event listeners and initialization
document.addEventListener('DOMContentLoaded', () => {
  loadCriticalResources();
  initializeLazyLoading();
  
  window.addEventListener('scroll', initializeLazyLoading, { passive: true });
  window.addEventListener('resize', initializeLazyLoading, { passive: true });
  
  setTimeout(() => {
    loadDeferredScripts();
    document.body.classList.add('wnw_loaded');
  }, config.deferredTimeout);
});

// Shopify-specific optimizations
if (!Shopify.designMode && !window.location.pathname.includes('/cart') && !window.location.pathname.includes('/checkout')) {
  // Load analytics and performance monitoring scripts
  setTimeout(() => {
    const analyticsScripts = document.querySelectorAll('.analytics, .boomerang');
    analyticsScripts.forEach(script => {
      const newScript = document.createElement('script');
      newScript.textContent = script.textContent;
      script.parentNode.replaceChild(newScript, script);
    });
  }, 100);
}